import { isEmpty } from 'lodash';
import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    filteredById: {},
    archivedById: {},
    loading: false,
    byPerma: {}
});

export default (state = getInitialState(), action) => {
    let newById;
    let reduced;
    let newArchivedById;
    let newCompanyExclusiveById;
    switch (action.type) {
        case ACTIONS.GET_MANY_PATHWAYS_START: {
            return {
                ...state,
                loading: true
            };
        }

        case ACTIONS.GET_MANY_PATHWAYS: {
            newById = { ...state.byId };
            const { pathways } = action.payload;
            pathways.forEach((pathway) => {
                newById[pathway._id] = pathway;
            });

            return {
                ...state,
                byId: newById,
                loading: false
            };
        }

        case ACTIONS.GET_PATHWAY:
        case ACTIONS.PUT_PATHWAY_SUCCESS:
        case ACTIONS.POST_PATHWAY_SUCCESS: {
            const { pathway } = action.payload;

            newById = {
                ...state.byId,
                [pathway._id]: pathway
            };
            return {
                ...state,
                byId: newById,
                loading: false,
                currentId: pathway._id
            };
        }

        case ACTIONS.CLEAR_SEARCHED_PATHWAYS: {
            return {
                ...state,
                loading: false,
                filteredById: {}
            };
        }

        case ACTIONS.GET_FILTERED_PATHWAYS: {
            const { pathways } = action.payload;
            reduced = {};
            newById = {
                ...state.byId
            };
            pathways.forEach((pathway) => {
                newById[pathway._id] = pathway;
                reduced[pathway._id] = pathway;
            });

            return {
                ...state,
                byId: newById,
                loading: false,
                filteredById: reduced
            };
        }

        case ACTIONS.GET_MANY_ARCHIVED_PATHWAYS: {
            const { pathways } = action.payload;

            newArchivedById = {
                ...state.archivedById
            };

            pathways.forEach((pathway) => {
                newArchivedById[pathway._id] = pathway;
            });

            return {
                ...state,
                archivedById: newArchivedById
            };
        }

        case ACTIONS.PUT_ARCHIVED_PATHWAY_SUCCESS: {
            const { pathway } = action.payload;
            newById = {
                ...state.byId
            };

            newArchivedById = {
                ...state.archivedById,
                [pathway._id]: pathway
            };

            const newFilteredById = {
                ...state.filteredById
            };

            if (pathway._id in newById) {
                delete newById[pathway._id];
            }

            if (pathway._id in newFilteredById) {
                delete newFilteredById[pathway._id];
            }

            return {
                ...state,
                byId: newById,
                loading: false,
                archivedById: newArchivedById,
                filteredById: newFilteredById
            };
        }

        case ACTIONS.PUT_UNARCHIVED_PATHWAY_SUCCESS: {
            const { pathway } = action.payload;
            newById = {
                ...state.byId,
                [pathway._id]: pathway
            };

            newArchivedById = {
                ...state.archivedById
            };
            const newFilteredById = {
                ...state.filteredById
            };
            if (!isEmpty(state.filteredById)) {
                newFilteredById[pathway._id] = pathway;
            }

            if (pathway._id in newArchivedById) {
                delete newArchivedById[pathway._id];
            }

            return {
                ...state,
                byId: newById,
                loading: false,
                archivedById: newArchivedById,
                filteredById: newFilteredById
            };
        }

        case ACTIONS.DELETE_PATHWAY_SUCCESS: {
            const { pathway } = action.payload;
            newById = {
                ...state.byId
            };

            const newFilteredById = {
                ...state.filteredById
            };

            if (pathway._id in newById) {
                delete newById[pathway._id];
            }

            if (pathway._id in newFilteredById) {
                delete newFilteredById[pathway._id];
            }

            return {
                ...state,
                byId: newById,
                loading: false,
                filteredById: newFilteredById
            };
        }

        case ACTIONS.GET_COMPANY_EXCLUSIVEPATHWAYS_SUCCESS: {
            const { pathways } = action.payload;

            newCompanyExclusiveById = {
                ...state.archivedById
            };

            pathways.forEach((pathway) => {
                newCompanyExclusiveById[pathway._id] = pathway;
            });

            return {
                ...state,
                companyExclusiveById: newCompanyExclusiveById
            };
        }

        default:
            return state;
    }
};
